export default "__VITE_ASSET__gRLGklQM__"